import type { TFunction } from "i18next";
import type { AgencyPostingFailure } from "./models";

type ShowSnackbar = (message: string, severity: "success" | "info" | "warning" | "error") => void;

/**
 * Emit one warning snackbar per non-fatal agency-sync failure. Failures are structured
 * (`{ agency, action }`); we translate each via `agency.failed.<action>`, interpolating the agency
 * display label. Shared so the warning copy/loop lives in one place across every agency-aware mutation.
 */
export const showAgencyWarnings = (showSnackbar: ShowSnackbar, t: TFunction, failures?: AgencyPostingFailure[]): void => {
	for (const failure of failures ?? []) {
		showSnackbar(t(`agency.failed.${failure.action}`, { agency: failure.agency }), "warning");
	}
};

/**
 * Show the success snackbar for an agency-aware staffing mutation, then the per-failure warnings.
 */
export const showAgencyPostingResult = (showSnackbar: ShowSnackbar, successMessage: string, t: TFunction, failures?: AgencyPostingFailure[]): void => {
	showSnackbar(successMessage, "success");
	showAgencyWarnings(showSnackbar, t, failures);
};
